(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  document.querySelectorAll('[data-pfh-mobile-filters]').forEach((panel) => {
    const toggle = document.querySelector(`[aria-controls="${panel.id}"]`);
    const close = panel.querySelector('.pfh-mobile-filter-close');
    if (!toggle || !close) return;
    const backdrop = document.createElement('div');
    backdrop.className = 'pfh-mobile-filter-backdrop';
    backdrop.hidden = true;
    document.body.append(backdrop);
    let savedStyle;
    let scrollY;
    let inertElements = [];
    const headings = panel.querySelectorAll('.widget-collapse h5, .custom-sidebar > div > section h5');
    const expanded = (heading) => {
      const content = heading.nextElementSibling;
      return content && getComputedStyle(content).display !== 'none';
    };
    // Keep the existing accordion click handlers and add keyboard access on phones.
    headings.forEach((heading) => {
      heading.addEventListener('keydown', (event) => {
        if (mobile.matches && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          heading.click();
        }
      });
      heading.addEventListener('click', () => {
        if (mobile.matches) heading.setAttribute('aria-expanded', String(!expanded(heading)));
        window.setTimeout(() => {
          if (mobile.matches) heading.setAttribute('aria-expanded', String(expanded(heading)));
        }, 450);
      }, true);
    });
    function hide(restoreFocus = true) {
      if (!panel.classList.contains('is-open')) return;
      panel.classList.remove('is-open');
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      panel.removeAttribute('aria-label');
      toggle.setAttribute('aria-expanded', 'false');
      backdrop.hidden = true;
      inertElements.forEach((element) => { element.inert = false; });
      inertElements = [];
      if (savedStyle === null) document.body.removeAttribute('style');
      else document.body.setAttribute('style', savedStyle);
      window.scrollTo(0, scrollY);
      if (restoreFocus) toggle.focus({ preventScroll: true });
    }
    toggle.addEventListener('click', () => {
      if (!mobile.matches) return;
      savedStyle = document.body.getAttribute('style');
      scrollY = window.scrollY;
      Object.assign(document.body.style, {
        position: 'fixed', top: `-${scrollY}px`, width: '100%', overflow: 'hidden'
      });
      panel.classList.add('is-open');
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-label', 'Filters');
      toggle.setAttribute('aria-expanded', 'true');
      backdrop.hidden = false;
      // Inert sibling branches without disabling the panel's ancestors.
      for (let branch = panel; branch !== document.body; branch = branch.parentElement) {
        Array.from(branch.parentElement.children).forEach((element) => {
          if (element !== branch && element !== backdrop && !element.inert) {
            element.inert = true;
            inertElements.push(element);
          }
        });
      }
      close.focus({ preventScroll: true });
    });
    close.addEventListener('click', () => hide());
    backdrop.addEventListener('click', () => hide());
    panel.addEventListener('keydown', (event) => {
      if (!panel.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        hide();
      }
      if (event.key !== 'Tab') return;
      const items = Array.from(panel.querySelectorAll('a[href], button, input, select, textarea, [tabindex="0"]'))
        .filter((item) => !item.disabled && item.getClientRects().length && getComputedStyle(item).visibility !== 'hidden');
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    function sync() {
      if (!mobile.matches) hide(false);
      headings.forEach((heading) => {
        if (mobile.matches) {
          heading.setAttribute('role', 'button');
          heading.setAttribute('tabindex', '0');
          heading.setAttribute('aria-expanded', String(expanded(heading)));
        } else {
          ['role', 'tabindex', 'aria-expanded'].forEach((name) => heading.removeAttribute(name));
        }
      });
    }
    mobile.addEventListener('change', sync);
    sync();
  });
})();
